import React from 'react'
import styles from '../../assets/stylesheets/pages/sale_products/ratings.module.scss'

export function NumberRatingScaleRating({ rating, columnName }) {
  if (!rating) { return null }
  const varName = rating.name.replace(/\s+/g, '-').toLowerCase()
  return (
    <td
      data-column-name={columnName}
      data-sale-rating={rating.description}
      title={rating.description}
    >
      <div
        className={styles[varName]}
      >
        {rating.rank}
      </div>
    </td>
  )
}
